/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Missingrequiredfielderror3Inputs */

const en_missingrequiredfielderror3 = /** @type {(inputs: Missingrequiredfielderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A required field is missing.`)
};

const de_missingrequiredfielderror3 = /** @type {(inputs: Missingrequiredfielderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein erforderliches Feld fehlt.`)
};

/**
* | output |
* | --- |
* | "A required field is missing." |
*
* @param {Missingrequiredfielderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const missingrequiredfielderror3 = /** @type {((inputs?: Missingrequiredfielderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missingrequiredfielderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_missingrequiredfielderror3(inputs)
	return de_missingrequiredfielderror3(inputs)
});
export { missingrequiredfielderror3 as "missingRequiredFieldError" }